import mixpanel from 'mixpanel-browser';
 
const MIXPANEL_TOKEN = `2f8562e8650b54bc0e453dfcb7964f2c`;
 
export const initMixpanel = () => {
  if (!MIXPANEL_TOKEN) {
    console.warn('Mixpanel token is missing! Check your .env file.');
    return;
  }
 
  // @ts-ignore
  mixpanel.init(MIXPANEL_TOKEN, { autocapture: true });
}